/* Tysk katalog for locale-journal-recovery-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'journalRecovery.title': 'Die Buchhaltung ist vorübergehend nicht verfügbar',
  'journalRecovery.description': 'Das Journal konnte nicht geprüft werden. Buchhaltungsseiten und Änderungen sind gesperrt, bis die Prüfung erfolgreich ist. Du kannst den Support kontaktieren oder im Menü das Unternehmen wechseln.',
  'journalRecovery.reference': 'Unternehmen: {businessId} · Geschäftsjahr: {year}',
  'journalRecovery.retry': 'Erneut versuchen',
  'journalRecovery.retrying': 'Wird geprüft …',
  'journalRecovery.support': 'Support kontaktieren',
  'journalRecovery.signOut': 'Abmelden',
  'journalRecovery.writeBlocked': 'Die Journalgrundlage ist nicht verfügbar. Versuche es erneut, bevor du die Buchhaltung änderst.',
});
